import { createContext, use } from 'react';

export interface StepUpRuntime {
  readonly username: () => string | undefined;
}

/** O `username` do Cognito, dado pela casca (`StepUpProvider`). Arquivo próprio: o formulário lê e o provider monta. */
export const StepUpRuntimeContext = createContext<StepUpRuntime | null>(null);

export function useStepUpRuntime(): StepUpRuntime {
  const runtime = use(StepUpRuntimeContext);
  if (!runtime) throw new Error('StepUpProvider ausente: a casca autenticada precisa montá-lo');
  return runtime;
}
